import React from 'react';
import {
  Box, Paper, Button, Stack,
  Text, Title, Center
} from '@mantine/core';
import { IconShield } from '@tabler/icons-react';
import { useAuth } from '../hooks/useAuth';
import { LoginForm } from './forms/LoginForm';
import classes from './LoginPage.module.css';

export default function LoginPage() {
  const { login, loading } = useAuth();

  const handleLogin = async (formData) => {
    await login(formData.username, formData.password);
  };

  return (
    <Box className={classes.root}>
      <Center style={{ minHeight: '100vh', height: '100vh' }}>
        <Paper className={classes.paper} radius="md" p="xl">
          <Center mb="lg">
            <IconShield size={48} color="#9381ff" />
          </Center>
          
          <Title order={2} ta="center" mb="xs" c="#2d2d2d" style={{ fontFamily: "'Roboto', sans-serif" }}>
            Help Desk Login
          </Title>
          <Text c="dimmed" size="sm" ta="center" mb="xl">
            Sign in to access your dashboard
          </Text>

          <LoginForm onSubmit={handleLogin} loading={loading} />
        </Paper>
      </Center>
    </Box>
  );
}
